var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDailyReportsIconOnboarding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 6.55,
    y: 22.61,
    width: 6.59,
    height: 11.86,
    style: {
      fill: "#62a3ef"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.71,
    y: 16.37,
    width: 6.59,
    height: 18.1,
    style: {
      fill: "#62a3ef"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.86,
    y: 6.68,
    width: 6.59,
    height: 27.79,
    style: {
      fill: "#62a3ef"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyReportsIconOnboarding);
export default __webpack_public_path__ + "static/media/daily_reports_icon_onboarding.8194353d80a7b4b30b6a216ff7d97023.svg";
export { ForwardRef as ReactComponent };